import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue"
import {
  CountriesQuery,
  MissionLifecycle,
  ListClientsQuery,
  ConsultantsSearchQuery,
  MissionLifecyclesListQuery,
} from "@/gql"
import UserChip from "@/components/content/UserChip.vue"
import AppPage from "@/components/layout/AppPage.vue"
import { ActionType } from "@/components/widgets/common/FilterBar.vue"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import Table from "@/components/widgets/data/Table.vue"
import useRouter from "@/router/useRouter"
import { useTranslation } from "@/i18n/useTranslation"
import NewProjectWizard from "@/modules/Missions/CreateNewProject/NewProjectWizard.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Missions',
  setup(__props) {

const { router, routes } = useRouter()
const { t } = useTranslation("Missions/ListMissions")

const showAddLeadForm = ref(false)
const countriesQuery = CountriesQuery
const listClientsQuery = ListClientsQuery
const consultantsSearchQuery = ConsultantsSearchQuery
const query = MissionLifecyclesListQuery
const queryVars = ref<{ [key: string]: any } | null>(null)
const headers = ref([
  { text: "Name", value: "name", custom: true, width: "25%" },
  { text: "Client", value: "client", custom: true, sortable: false },
  { text: "Service", value: "scopeService", custom: true, sortable: false },
  { text: "Stage", value: "state", custom: true, sortable: false },
  { text: "Mission Manager", value: "manager", sortable: false, custom: true },
])

const itemActions: ActionType = {
  "View mission": (mission: MissionLifecycle) => gotoDetailPage(mission),
}

const queries = computed<RefetchQueryDescription>(() => ["missionLifecyclesQuery"])

const gotoDetailPage = (mission: MissionLifecycle) => {
  router.push({ name: routes.MissionDetail, params: { id: mission.id.toString() } })
}

onMounted(() => {
  const tableRef = ref<Table | null>(null)
  queryVars.value = tableRef.value?.queryVars || null
})

const getStateColor = (state: string) => {
  const colors: Record<string, string> = {
    lead_stage: "brown lighten-5 brown--text text--darken-3",
    scoping_stage: "brown lighten-5 brown--text text--darken-3",
    contracting_stage: "yellow lighten-5 yellow--text text--darken-3",
    proposal_stage: "yellow lighten-5 yellow--text text--darken-3",
    staffing_stage: "lime lighten-5 lime--text text--darken-3",
    execution_stage: "light-green lighten-5 light-green--text text--darken-3",
    completed: "teal lighten-5 teal--text text--darken-3",
  }
  return colors[state] || "grey lighten-2"
}

return { __sfc: true,router, routes, t, showAddLeadForm, countriesQuery, listClientsQuery, consultantsSearchQuery, query, queryVars, headers, itemActions, queries, gotoDetailPage, getStateColor, UserChip, AppPage, Table, NewProjectWizard }
}

})